export default __webpack_public_path__ + "a67c6ff211f4c1883fff1dc3a4a59d82.svg";